export default __webpack_public_path__ + "static/media/brand_scotia_amex.60169032.svg";